import React from 'react';
import { Grid, GridCol } from 'pageFramework/uiControls/layouts';
import { ReadOnlyField, ReadOnlyDateField } from 'pageFramework/uiControls/inputs';
import { CalendarWindows } from 'types';
import moment from 'moment';

interface WindowDetailsViewProps {
	details?: CalendarWindows | null;
}

export const WindowDetailsView: React.FC<React.PropsWithChildren<WindowDetailsViewProps>> = (props) => {
	const { details } = props;
	let weekDays = details?.windowRecurrencePattern?.recurringDays?.map(x => x.weekDay).join(", ")
	return (
		<>
			<Grid numberOfColumns={3}>
				<GridCol span="fill">
					<ReadOnlyField label="Ruleset">
						{details?.ruleset.name}
					</ReadOnlyField>
				</GridCol>
				<GridCol>
					<ReadOnlyDateField label="Date" date={details?.dateTimeInfo.date} />
				</GridCol>
				<GridCol>
					<ReadOnlyField label="Start Time">
						{details?.dateTimeInfo && moment(details?.dateTimeInfo.startTime, 'HH:mm:ss').format('hh:mm A')}
					</ReadOnlyField>
				</GridCol>
				<GridCol>
					<ReadOnlyField label="End Time">
						{details?.dateTimeInfo && moment(details?.dateTimeInfo.endTime, 'HH:mm:ss').format('hh:mm A')}
					</ReadOnlyField>
				</GridCol>
			</Grid>
		
			{details?.windowRecurrencePattern &&
				<Grid numberOfColumns={2}>
					<GridCol>
						<ReadOnlyField label="Recurrence">
							{details?.windowRecurrencePattern?.recurrenceType} {details?.windowRecurrencePattern?.weekFrequency && ", every " + details?.windowRecurrencePattern?.weekFrequency + " week(s)"}
						</ReadOnlyField>
					</GridCol>
					<GridCol>
						<ReadOnlyField label="Recurring Days">
							{details?.windowRecurrencePattern?.recurringDays && weekDays}{details?.windowRecurrencePattern?.weekFrequency === null ? details?.windowRecurrencePattern?.isDailyRecurrence ? "Everyday" : "Every Weekday" : ''}
						</ReadOnlyField>
					</GridCol>
					<GridCol>
						<ReadOnlyField label="Start Recurrence">
							{details?.windowRecurrencePattern && moment(details?.windowRecurrencePattern?.startRecurrence).format('YYYY-MM-DD')}
						</ReadOnlyField>
					</GridCol>
					<GridCol>
						<ReadOnlyField label="End Recurrence">
							{details?.windowRecurrencePattern?.endRecurrence && moment(details?.windowRecurrencePattern?.endRecurrence).format('YYYY-MM-DD')}
							{details?.windowRecurrencePattern?.totalRecurrence && "After " + details?.windowRecurrencePattern?.totalRecurrence + " occurrences"}
						</ReadOnlyField>
					</GridCol>
				</Grid>
			}
		</>
	);
};

export default WindowDetailsView;
